import React from 'react';
import {Form, Formik} from "formik";
import CheckBoxInput from "../../../../../Common/components/checkbox-input";
import {formatFormTitle, FormikMultiFormSync} from "../../../../../../util/Helpers";

function Disclosure(
    {
        dataKey,
        title,
        isEditable,
        initialValues: {
            disclosuresData = {}
        }
    }
) {

    const compiledInitialValues = {
        acceptTerms: !!disclosuresData?.signedBy
    }

    return (
        <div>
            <Formik
                initialValues={compiledInitialValues}
                validateOnMount={true}
                enableReinitialize={true}
            >
                {({isValid, values}) =>
                    <Form>
                        <fieldset disabled={!isEditable || disclosuresData?.signedBy}>
                            {formatFormTitle({title, isValid, isRequired: false})}
                            <CheckBoxInput
                                name="acceptTerms"
                                checked={values.acceptTerms}
                            >
                                Accept Terms of use on behalf of the user*
                            </CheckBoxInput>
                            <FormikMultiFormSync name={dataKey}/>
                        </fieldset>
                    </Form>
                }
            </Formik>
        </div>
    );
}

export default Disclosure;